import { FormationCertificateDtoClient } from "@/api/dto/formation-certificate.dto";
import { FormationTypeDescriptions } from "@/api/enums/FormationType";
import { ValidationStatus } from "@/api/enums/ValidationStatus";
import { useFormationInstitutesQuery } from "@/api/formation-institute/formation-institute";
import { Badge } from "@/components/atoms/Badge";
import { Input } from "@/components/atoms/Input";
import { Skeleton } from "@/components/atoms/Skeleton";
import PerimeterDisplay from "@/components/pages/Candidate/Dashboard/Exams/Home/Registrations/RegistrationCard/DetailsDialog/PerimeterDisplay";
import { Perimeter } from "@/lib/perimeter";
import { Ban, Check } from "lucide-react";
import FileLink from "../FileLink";
import LoadingError from "../LoadingError";

interface FormationAttestationDisplayProps {
  attestation: FormationCertificateDtoClient;
}

const FormationAttestationDisplay = ({
  attestation: {
    formationType,
    certificate,
    perimeter,
    formationInstituteId,
    status,
  },
}: FormationAttestationDisplayProps) => {
  const formationInstitutesQuery = useFormationInstitutesQuery();

  if (!formationInstitutesQuery.data) {
    if (formationInstitutesQuery.isLoading)
      return <Skeleton className="w-full h-full min-h-64" />;
    else return <LoadingError>Erreur de chargement du certificat</LoadingError>;
  }

  return (
    <div className="w-full flex flex-col gap-2">
      <div className="flex flex-row gap-2">
        {status === ValidationStatus.PENDING && (
          <Badge variant="orange">En attente d'acceptation</Badge>
        )}
        {status === ValidationStatus.REFUSED && (
          <>
            <Ban className="w-6 h-6 text-red-500" />
            <Badge variant="red">Refusée</Badge>
          </>
        )}
        {status === ValidationStatus.VALIDATED && (
          <Check className="w-6 h-6 text-green-500" />
        )}
      </div>
      <div className="flex flex-row w-full gap-2 mb-4">
        <div className="flex flex-col gap-1.5 w-1/2">
          <span>Type de formation</span>
          <Input
            value={FormationTypeDescriptions[formationType]}
            disabled={true}
          />
        </div>
        <div className="flex flex-col gap-1.5 w-1/2">
          <span>Organisme de formation</span>
          <Input
            value={
              formationInstitutesQuery.data.find(
                (institute) => institute.id === formationInstituteId
              )?.description
            }
            disabled={true}
          />
        </div>
      </div>
      <FileLink outerBox={true} file={certificate} variant="secondary" />
      <PerimeterDisplay perimeter={Perimeter.from(perimeter)} />
    </div>
  );
};

export default FormationAttestationDisplay;
